var exports = {
  "A": "xfd349460--2a0c28--item",
  "D": "xfd349460--2a0c28--title",
};

module.exports = exports;
